export const environment = {

    backendApiURL: 'https://nejlepsi-skolky.cz',
    mapyApiKey: 'WiK4KcBXkuKuPqbuyQLvvxUtXbdwa8mzdhtvRAlOWj0',
    serverUrl: 'https://nejlepsi-skolky.cz',
    suggestApiKey: 'WiK4KcBXkuKuPqbuyQLvvxUtXbdwa8mzdhtvRAlOWj0'
};
